import { PropsWithChildren } from 'react'

import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

export function H1({ children }: PropsWithChildren<{}>) {
  return (
    <Typography variant="h1" style={{ marginTop: '4rem' }}>
      {children}
    </Typography>
  )
}

export function H2({ children }: PropsWithChildren<{}>) {
  return (
    <Typography variant="h2" style={{ marginTop: '4rem' }}>
      {children}
    </Typography>
  )
}

export function H3({ children }: PropsWithChildren<{}>) {
  return (
    <Typography variant="h3" style={{ marginTop: '2rem' }}>
      {children}
    </Typography>
  )
}

export function P({ children }: PropsWithChildren<{}>) {
  return (
    <Typography variant="body1" paragraph={true} style={{ maxWidth: '70ch' }}>
      {children}
    </Typography>
  )
}

export function Ul({ children }: PropsWithChildren<{}>) {
  return <ul style={{ maxWidth: '70ch' }}>{children}</ul>
}

export function Li({ children }: PropsWithChildren<{}>) {
  return (
    <Typography variant="body1" paragraph={true} component="li">
      {children}
    </Typography>
  )
}

export function Strike({ children }: PropsWithChildren<{}>) {
  return <span style={{ textDecoration: 'line-through' }}>{children}</span>
}

/*
 * Inline monospace looking a step smaller than the surrounding prose
 */
const useCodeStyles = makeStyles(theme => ({
  code: {
    '&&': {
      fontFamily: '"Monaco", "Menlo", "Consolas", "Liberation Mono", monospace',
      fontSize: '0.85em',
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(255, 255, 255, 0.1)'
          : 'rgba(128, 70, 0, 0.05)',
      padding: '0.15em 0.4em',
      borderRadius: '3px',
      // Entity references and annotation keys are long and have no spaces.
      wordBreak: 'break-word'
    }
  }
}))

export function Code({ children }: PropsWithChildren<{}>) {
  const classes = useCodeStyles()
  return <code className={classes.code}>{children}</code>
}
